import React, { useEffect, Children, useState } from 'react';
import BigCalendar from 'react-big-calendar';
import "react-big-calendar/lib/css/react-big-calendar.css";
import Drawer from '@material-ui/core/Drawer';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';
import { Button, Grid, Typography } from "@material-ui/core";
import ExtraItemDrawer from 'components/CalendarControls/ExtraItemDrawer';
import { useSelector, useDispatch } from 'react-redux';
import { actionGetExtraItems, actionResetErrorMessage } from 'actions';
import Moment from 'moment';
import ErrorHandling from '../ErrorHandling/ErrorHandling';
import { actionResetDisplayAreas } from 'actions';
import { genfunction } from '../../helpers';
import { withRouter } from 'react-router';
import { actionShopCartSetManageMyBooking, actionShopCartResetMembership, actionShopCartResetIDME } from 'actions';
import { actionResetBooking } from 'actions';
import GroupReservationDrawer from './GroupReservationDrawer';


const { DefaultColor, EventNotAvailable, DefaultCostRateID, CalendarHeight, CalendarWidth, CalendarScreenDatTimeAlreadyBuyMsg,
  CalendarStartingHour, UnableToBuyTicketShowBookNowEnabled, UnableToBuyTicketShowBookNowDisabled, CalendarScreenMessage1, CalendarScreenMessage2 } = window['runConfig'];
const localizer = BigCalendar.momentLocalizer(moment);


const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  },
  list: {
    width: 400,
    fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"'
  }
  ,
  list2: {
    width: '100%',
    fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"'
  }
}));

const CalendarControl = (props) => {

  const classes = useStyles();

  let apiData = false;
  const dispatch = useDispatch();

  const tourEvents = useSelector(state => state.reducerExtraItems.extramItems);
  const bookingType = useSelector(state => state.reducerBookingTypes.bookingType);
  const errExtraItem = useSelector(state => state.reducerExtraItems.extramItemsError);
  const bookingTypes = useSelector(state => state.reducerBookingTypes.bookingTypes);
  const displayArea = useSelector(state => state.reducerDisplayAreas);
  const displayAreasState = useSelector(state => state.reducerDisplayAreas);
  const shopcartreducer = useSelector(state => state.reducerShopCart);
  const reducerBooking = useSelector(state => state.reducerBooking);
  const extraItem = useSelector(state => state.reducerExtraItems.extraItem);

  const [currentview, setcurrentview] = useState("");
  const [nextWeekDate, setnextWeekDate] = useState('');


  useEffect(() => {
    GetMonthlyRecords();
  }, []);

  useEffect(() => {

    if (nextWeekDate) {
      actionGetExtraItems(dispatch, props.urlID, true, displayArea.isDisplay ? true : false,
        Moment(nextWeekDate).format('YYYY-MM-DD'), null, "WeekView", null);
    }

  }, [nextWeekDate]);

  const GetMonthlyRecords = () => {

    let propsEvent = props.location.event;

    if (props.Path == "/calendar/:id") {
      actionResetDisplayAreas(dispatch);
      actionGetExtraItems(dispatch, props.urlID, true, false);
    }
    else {

      if (displayAreasState.displayAreas !== undefined && displayAreasState.displayAreas.length > 0) {
        let newDisplayAreas = JSON.parse(JSON.stringify(displayAreasState.displayAreas));
        let newObj = { ...newDisplayAreas.filter(x => x.DisplayAreaNo == props.urlID)[0] };

        propsEvent && Moment(propsEvent.EventDate).format('YYYY-MM') !== Moment(newObj.NextTourDate).format('YYYY-MM') ?
          actionGetExtraItems(dispatch, props.urlID, false, true, propsEvent.EventDate, null, null)
          :
          actionGetExtraItems(dispatch, props.urlID, true, true, newObj.NextTourDate, null, null);
      }
      else {
        propsEvent && Moment(propsEvent.EventDate).format('YYYY-MM') !== Moment(displayAreasState.displayArea.NextTourDate).format('YYYY-MM') ?
          actionGetExtraItems(dispatch, props.urlID, false, true, propsEvent.EventDate, null, null)
          :
          actionGetExtraItems(dispatch, props.urlID, true, true, displayAreasState.displayArea.NextTourDate, null, null);
      }
    }
  };


  const GetCostRate = () => {
    let cstrate = 0;

    if (shopcartreducer.membershipValidation.ismembershipApplied) {
      cstrate = shopcartreducer.membershipValidation.membershipcostrate;
    }
    else if (shopcartreducer.IDME.isIdMeApplied) {
      cstrate = shopcartreducer.IDME.idmecostrate;
    }
    else {
      cstrate = DefaultCostRateID;
    }

    return cstrate;
  }


  const GetDefaultDate = () => {

    if (bookingType !== undefined && bookingType.hasOwnProperty("NextTourDate")) {
      var year = Moment(bookingType.NextTourDate).format('YYYY');
      var month = Moment(bookingType.NextTourDate).format('MM');
      var dt = Moment(bookingType.NextTourDate).format('DD');

      return new Date(year, month - 1, dt);
    }
    else {
      var today = props.location.event ? new Date(props.location.event.EventDate) : new Date();
      return new Date(today.getFullYear(), today.getMonth(), today.getDate());
    }
  }

  if (tourEvents == undefined || tourEvents.length <= 0) {
    apiData = false;
  }
  else {
    apiData = true;
  }

  const constredirect = (products) => {
    props.constredirect(products);
  }

  let events = [];

  const ConvertTourEventsToEvents = (tourEvents) => {

    if ((tourEvents == 'nocontent' || tourEvents === undefined) ||
      (tourEvents.length > 0 && !tourEvents[0].hasOwnProperty("TourEventID"))) {
      return;
    }

    for (let j = 0; j < tourEvents.length; j++) {

      if (bookingTypes === undefined) {
        return;
      }

      const bookType = bookingTypes.filter(x => x.BookingTypeID == tourEvents[j].BookingTypeID)[0];

      if (tourEvents[j].BookNowOption === 'Past Event' || tourEvents[j].BookNowOption === 'Cancelled') {
        continue;
      }

      if (tourEvents[j].BookNowOption === 'Sold Out' &&
        tourEvents[j].EventStartDateTime < tourEvents[j].CurrentDateTimeAtLocation) {
        continue;
      }

      if (tourEvents[j].TourDisplayDays && tourEvents[j].TourDisplayDays > 0) {
        let lastdisplaydate = new Date(tourEvents[j].CurrentDateTimeAtLocation);
        lastdisplaydate.setDate(lastdisplaydate.getDate() + tourEvents[j].TourDisplayDays);
        if (new Date(tourEvents[j].EventStartDateTime) > lastdisplaydate)
          continue;
      }

      var event = {

        toureventID: tourEvents[j].TourEventID,
        allDay: false,
        start: new Date(tourEvents[j].EventStartDateTime),
        end: new Date(tourEvents[j].EventEndDateTime),
        title: StartAndEndTime(tourEvents, j, bookType) + GetWebDisplayName(tourEvents, j, bookType),
        color: tourEvents[j].DisplayColor,
        level: tourEvents[j].DisplayColorLevel,
        isExtraItem: false,
        startDate: Moment(tourEvents[j].EventStartDateTime).format('YYYY-MM-DD'),
        bookingTypeID: tourEvents[j].BookingTypeID,
        isSaleable: tourEvents[j].BookNowOption === 'Book Now' ? true : false,
        isSingleTour: false,
        notavailableReason: ''
      }




      if (bookType != undefined && bookType.hasOwnProperty("ShowAvailability") && bookType.ShowAvailability) {

        if (event.isSaleable)
          event.title += ' (' + tourEvents[j].SeatsAvailable + ' ' + bookType.AvailabilityText + ')';
        else
          event.title += ' (' + tourEvents[j].BookNowOption + ')';
        event.notavailableReason = tourEvents[j].BookNowOption;
      }

      if (shopcartreducer.managemybooking && reducerBooking.booking[0]) {

        if (reducerBooking.booking[0].TourEventID === event.toureventID) {
          event.isSaleable = false;
          event.title += ' (' + CalendarScreenDatTimeAlreadyBuyMsg + ')';
          event.notavailableReason = CalendarScreenDatTimeAlreadyBuyMsg;
        }
      }

      if (!event.isSaleable) {
        event.color = EventNotAvailable
      }

      var startEvent = Moment(tourEvents[j].EventStartDateTime).format('YYYY-MM-DD');

      if (!displayArea.isDisplay && events !== undefined &&
        events.filter(x => x.startDate == startEvent && x.isExtraItem).length == 0) {

        for (let k = 0; k < tourEvents[j].TourProducts.length; k++) {

          if (tourEvents[j].TourProducts[k].ShowOnCalendar) {

            var e = Object.assign({}, event);

            e.start = new Date(Moment(tourEvents[j].EventStartDateTime).format('YYYY-MM-DD 23:59:59'));
            e.end = new Date(Moment(tourEvents[j].EventEndDateTime).format('YYYY-MM-DD 23:59:59'));
            e.isExtraItem = true;
            e.isSingleTour = tourEvents.filter(x => Moment(x.EventStartDateTime).format('YYYY-MM-DD') == startEvent && x.BookNowOption !== 'Past Event' && x.BookNowOption !== 'Cancelled' && x.BookNowOption !== 'Sold Out').length > 1 ? false : true;

            if (tourEvents[j].TourProducts[k].hasOwnProperty("PriceMatrix")) {
              let pmatrix;

              if (tourEvents[j].TourProducts[k].PriceMatrix && tourEvents[j].TourProducts[k].PriceMatrix.length > 1)
                pmatrix = tourEvents[j].TourProducts[k].PriceMatrix.find(x => x.CostRateID == GetCostRate());
              else
                pmatrix = tourEvents[j].TourProducts[k].PriceMatrix ? tourEvents[j].TourProducts[k].PriceMatrix[0] : undefined;

              if (pmatrix) {
                e.title = tourEvents[j].TourProducts[k].TourProductName + ' ' + genfunction.ccyFormat(pmatrix ? pmatrix.Price : 0)
                events.push(e)
              }
            }
          }
        }
      }

      events.push(event);
    }
  }

  if (apiData) {
    ConvertTourEventsToEvents(tourEvents);
  }

  const [state, setState] = useState({
    right: false,
    tourEventId: 0,
    bookingTypeID: 0,
    errorMsg: '',
    bookingunsoldReson: '',
    isContinueToExtraItemDrawer: false,
    isContinueToGroupDrawer: false,
    organizationID: "",
    groupSize: "",
    isEditEvent: false
  });

  useEffect(() => {
    reloadEventForGroups(props.location.event);
  }, [bookingTypes, tourEvents]);

  const toggleDrawer = (side, open, event) => {

    if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    if (state.errorMsg.length > 0) {
      return;
    }

    if (event) {

      if ((event.isExtraItem && event.isSingleTour == false) || !event.isSaleable) {
        setState({ ...state, errorMsg: event.notavailableReason.length > 0 ? UnableToBuyTicketShowBookNowEnabled + event.notavailableReason : UnableToBuyTicketShowBookNowDisabled, bookingunsoldReson: event.notavailableReason.length > 0 ? event.notavailableReason : 'Sold Out' });
        return;
      }

      setState({ ...state, [side]: open, tourEventId: event.toureventID, bookingTypeID: event.bookingTypeID, bookingunsoldReson: '' });
    }
    else {

      props.location.event = null;
      setState({ ...state, [side]: open, tourEventId: 0, bookingunsoldReson: '', groupSize: "", organizationID: "", isContinueToExtraItemDrawer: false, isContinueToGroupDrawer: false, isEditEvent: false });
    }
  };

  const checkIsReloadEvent = (event) => {

    let reloadEvent = false;

    if (genfunction.IsEditEvent(bookingTypes, extraItem)) {

      if (shopcartreducer.events && shopcartreducer.events.length > 0 && shopcartreducer.events.find(x => x.TourEventID == event.toureventID)) {
        reloadEvent = true;
        event = shopcartreducer.events.filter(x => x.TourEventID == event.toureventID)[0];

      }

      reloadEvent ? reloadEventForGroups(event) : toggleDrawer('right', true, event);

    }
    else {
      toggleDrawer('right', true, event);
    }

  }

  const reloadEventForGroups = (event) => {

    if (event && event.hasOwnProperty("TourEventID")) {

      setState({
        ...state,
        right: true,
        tourEventId: event.TourEventID,
        bookingTypeID: event.BookingTypeID,
        selectedDate: new Date(event.EventDate),
        groupSize: event.GroupSize,
        organizationID: event.OrganizationID,
        isContinueToGroupDrawer: event.OrganizationID !== "" ? true : false,
        isEditEvent: true
      });
    }

  }

  const setIsEditEvent = (value) => {
    setState({
      ...state, isEditEvent: value
    });
  }

  const goToExtraItemOrGroupDrawer = (value) => {
    setState({ ...state, isContinueToExtraItemDrawer: value, isContinueToGroupDrawer: !value });
  }

  const showGroupDrawer = () => {

    const bType = bookingTypes.filter(x => x.BookingTypeID == state.bookingTypeID)[0];

    if (bType && !state.isContinueToExtraItemDrawer) {
      if (bType.RequireCompanyName || bType.ShowTourProductsBasedOnGroupSize || state.isContinueToGroupDrawer)
        return true;
    }

    return false
  }

  const onChangeOrganization = (value) => {

    value ? setState({ ...state, organizationID: value.CustomerID }) : setState({ ...state, organizationID: "" })
  }

  const onChangeGroupSize = (value) => {

    value ? setState({ ...state, groupSize: value.GroupSize }) : setState({ ...state, groupSize: "" })

  }

  const sideList = side => {

    return (
      < div className={window.matchMedia("(min-width: 600px)").matches ? classes.list : classes.list2} role="presentation" >

        {showGroupDrawer() ?

          <GroupReservationDrawer goToExtraItemOrGroupDrawer={goToExtraItemOrGroupDrawer}
            ismembershipapplied={shopcartreducer.membershipValidation.ismembershipApplied}
            membercostrate={shopcartreducer.membershipValidation.membershipcostrate}
            isIDME={shopcartreducer.IDME.isIdMeApplied}
            isIDMECostrate={shopcartreducer.IDME.idmecostrate}
            organizationID={state.organizationID} groupSize={state.groupSize}
            onChangeOrganization={onChangeOrganization}
            onChangeGroupSize={onChangeGroupSize}
            bookingtypeID={state.bookingTypeID} tourEventId={state.tourEventId} toggleDrawer={toggleDrawer}
            isEditEvent={state.isEditEvent} toggleIsEdit={setIsEditEvent} isContinueToGroupDrawer={state.isContinueToGroupDrawer}
          />
          :
          <ExtraItemDrawer tourEventId={state.tourEventId}
            ismembershipapplied={shopcartreducer.membershipValidation.ismembershipApplied}
            membercostrate={shopcartreducer.membershipValidation.membershipcostrate}
            isIDME={shopcartreducer.IDME.isIdMeApplied}
            isIDMECostrate={shopcartreducer.IDME.idmecostrate}
            cstrate={GetCostRate()} bookingtypeID={state.bookingTypeID} callCheckout={constredirect}
            toggleDrawer={toggleDrawer} isEditEvent={state.isEditEvent}
            groupSize={state.groupSize} organizationID={state.organizationID}
            goToExtraItemOrGroupDrawer={goToExtraItemOrGroupDrawer} isContinueToExtraItemDrawer={state.isContinueToExtraItemDrawer}

          />

        }

      </div >)
  };

  const onView = (view) => {
    setcurrentview(view);
  }

  useEffect(() => {

    if (currentview === "week") {
      if (nextWeekDate) {
        actionGetExtraItems(dispatch, props.urlID, true, displayArea.isDisplay ? true : false,
          Moment(nextWeekDate).format('YYYY-MM-DD'), null, "WeekView");
      }
    }

    if (currentview === "month") {
      var today = new Date();
      var date = new Date(today.getFullYear(), (today.getMonth()), today.getDate());

      if (currentview === "" || currentview === "month") {

        var headerValue = document.getElementsByClassName('rbc-toolbar-label')[0].textContent;
        var month = moment(headerValue).format('MM');
        var year = moment(headerValue).format('YYYY');
        var newMonth = year + '-' + month + '-' + 1;

        if (today.getMonth() + 1 == month) {
          actionGetExtraItems(dispatch, props.urlID, true, displayArea.isDisplay ? true : false, Moment(date).format('YYYY-MM-DD'));
        }
        else {
          actionGetExtraItems(dispatch, props.urlID, false, displayArea.isDisplay ? true : false, Moment(newMonth).format('YYYY-MM-DD'));
        }

      }
    }
  }, [currentview]);

  const FetchNewMonthDataHandler = (event) => {

    var defaultDate = GetDefaultDate();
    var today = new Date();
    var date = new Date(today.getFullYear(), (today.getMonth()), today.getDate());

    if (currentview === "" || currentview === "month") {
      if (defaultDate.getMonth() == event.getMonth()) {
        actionGetExtraItems(dispatch, props.urlID, true, displayArea.isDisplay ? true : false, Moment(event).format('YYYY-MM-DD'));
      }
      else if (event >= date) {
        actionGetExtraItems(dispatch, props.urlID, false, displayArea.isDisplay ? true : false, Moment(event).format('YYYY-MM-DD'));
      }
    }

    if (currentview === "day") {
      actionGetExtraItems(dispatch, props.urlID, true, displayArea.isDisplay ? true : false, Moment(event).format('YYYY-MM-DD'), null, "SingleDay");
    }
  }

  const errorcancelhandle = () => {
    actionResetErrorMessage(dispatch);
    setState({ ...state, right: false, errorMsg: '', bookingunsoldReson: '' });
  }

  // example implementation of a wrapper
  const ColoredDateCellWrapper = ({ children, value }) =>
    React.cloneElement(Children.only(children), {
      style: {
        ...children.style,
        backgroundColor: BackgroundColor(value)
      },
    });


  const eventStyleGetter = (event) => {
    var style = {
      backgroundColor: event.color !== undefined ? event.color : DefaultColor,
      borderRadius: '0px',
      opacity: 1,
      border: '0px',
      display: (currentview === "week" || currentview === "day") && event.isExtraItem !== undefined && event.isExtraItem ? 'none' : 'block',
      cursor: event.isExtraItem !== undefined && event.isExtraItem && event.isSingleTour == false ? 'default' : 'pointer',
      'pointer-events': event.isExtraItem !== undefined && event.isExtraItem && event.isSingleTour == false ? 'none' : 'auto',
      'font-weight': event.isExtraItem !== undefined && event.isExtraItem ? 'unset' : 'bold'
    };
    return {
      style: style
    }
  }

  const BackgroundColor = (date) => {

    if (!displayArea.isDisplay) {
      let a = Moment(date).format('YYYY-MM-DD');

      if (events !== undefined && events.length > 0) {
        let event = events.filter(x => x.startDate == a && x.isExtraItem == false)[0];

        if (event !== undefined) {
          if (event.color !== undefined) {
            return event.color;
          }

          return DefaultColor;

        }
      }
    }

  };



  const minTime = new Date();
  minTime.setHours(CalendarStartingHour, 0, 0);

  const constredirecttofindmybpooking = () => {
    actionResetBooking(dispatch);
    actionShopCartResetMembership(dispatch);
    actionShopCartResetIDME(dispatch);
    actionShopCartSetManageMyBooking(dispatch, false, false);

    props.history.push({
      pathname: '/findmybooking'
    })

  }

  const redirecttoconfirmbookingchanges = (event) => {

    if (shopcartreducer.managemybooking && reducerBooking.booking[0] && event.isSaleable) {

      if (reducerBooking.booking[0].TourEventID !== event.toureventID) {
        props.history.push({
          pathname: '/confimbookingchanges',
          eventID: event.toureventID,
          ismembershipapplied: shopcartreducer.membershipValidation.membershipcostrate,
          membercostrate: shopcartreducer.membershipValidation.membershipcostrate,
          bookingtypeID: event.bookingTypeID

        })
      }
    }
    else {
      if (event.notavailableReason.length > 0) {
        setState({ ...state, errorMsg: event.notavailableReason.length > 0 ? UnableToBuyTicketShowBookNowEnabled + event.notavailableReason : UnableToBuyTicketShowBookNowDisabled, bookingunsoldReson: event.notavailableReason.length > 0 ? event.notavailableReason : 'Sold Out' });
        return;
      }
    }
  }


  return (
    <Grid id="vt_component_tour_calendar" container className={classes.root + " " + classes.content}>

      <ErrorHandling msg={errExtraItem.length > 0 ? errExtraItem : state.errorMsg} open={errExtraItem.length > 0 || state.errorMsg != "" ? true : false} handleclose={errorcancelhandle} />
      <Grid container alignItems="center" item xs={12} ms={12} lg={12} className="CalenderWrapper">

        {shopcartreducer.managemybooking && reducerBooking.booking[0] && reducerBooking.booking[0].hasOwnProperty('AllowDateTimeChanges') && !reducerBooking.booking[0].AllowDateTimeChanges ?
          <>
            <Grid item align="center" xs={12} ms={12} lg={12}>

              <Typography variant="h4" style={{ padding: "10px" }} >
                {reducerBooking.booking[0].hasOwnProperty('NoChangesMessage') ? reducerBooking.booking[0].NoChangesMessage : 'Date Time Changes are not allowed.'}
              </Typography>
              <Button variant="outlined" size="medium" color="primary"
                style={{ padding: "10px" }}
                onClick={() => constredirecttofindmybpooking()}>
                Cancel Changes
              </Button>
            </Grid>
          </>
          :
          <>
            {
              shopcartreducer.managemybooking ?
                <Grid item align="center" xs={12} ms={12} lg={12}>

                  <Typography variant="h4" style={{ padding: "10px" }} >
                    {CalendarScreenMessage1} {moment(reducerBooking.booking[0].EventStartDateTime).format('dddd,MMMM D')} at  {moment(reducerBooking.booking[0].EventStartDateTime).format('LT')} {CalendarScreenMessage2}
                  </Typography>
                  <Button variant="outlined" size="medium" color="primary"
                    style={{ padding: "10px" }}
                    onClick={() => constredirecttofindmybpooking()}>
                    Cancel Changes
                  </Button>
                </Grid> : null
            }



            {events !== undefined ?
              <BigCalendar style={{ width: CalendarWidth, height: CalendarHeight, margin: "0 auto", overflow: "auto" }}
                localizer={localizer}
                defaultView="month"
                events={events}
                min={minTime}
                popup={true}
                onSelectEvent={(event) => {
                  shopcartreducer.managemybooking ? redirecttoconfirmbookingchanges(event) :
                    checkIsReloadEvent(event, 'right', true)
                }}
                onView={onView}
                onNavigate={(event) => {
                  FetchNewMonthDataHandler(event);
                }}
                views={['month', 'week']}
                defaultDate={GetDefaultDate()}
                eventPropGetter={(eventStyleGetter)}
                components={{
                  dateCellWrapper: ColoredDateCellWrapper
                }}
                formats={{
                  dayRangeHeaderFormat: ({ start, end }) => {

                    if (moment(nextWeekDate).format('DD/MM/YYYY') !== moment(start).format('DD/MM/YYYY')) {
                      setnextWeekDate(start);
                    }

                    return (moment(start).format('MMMM DD')) + ' - ' + (moment(end).format('MMMM DD'));
                  },
                  monthHeaderFormat: "MMMM YYYY",
                }}
              />
              : null
            }
            <div>
              <Drawer anchor="right" open={state.right} onClose={() => toggleDrawer('right', false)}>
                {sideList('right')}
              </Drawer>
            </div>
          </>


        }
      </Grid>
    </Grid >
  );
}

export default withRouter(CalendarControl);

function StartAndEndTime(tourEvents, j, bookType) {
  let time = "";

  if (bookType) {
    if (bookType.ShowStartTime) {
      time += Moment(tourEvents[j].EventStartDateTime).format('hh:mm a');
    }

    if (bookType.ShowEndTime && !bookType.ShowStartTime) {
      time += Moment(tourEvents[j].EventEndDateTime).format('hh:mm a')
    }

    if (bookType.ShowEndTime && bookType.ShowStartTime) {
      time += ' - ' + Moment(tourEvents[j].EventEndDateTime).format('hh:mm a')
    }

    time += ' ';
  }
  return time;
}

function GetWebDisplayName(tourEvents, j, bookingType) {
  return bookingType ? tourEvents[j].EventName : '';
}
